import TableAHSF from "../../../Components/TableAHSF";
import ObjectivesActivitiesAddEdit from "./ObjectivesActivitiesAddEdit";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { DeleteObjectivesActivities } from "../../../Redux/Reducers/BudgetInformation/ObjectivesActivities";
import PopupAHSF from "../../../Components/PopupAHSF";
import { useEffect, useState } from "react";
import { setRefreshTable } from "../../../Redux/Reducers/VariousVariables";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const ObjectivesActivities = () => {
  const AppGuid = useParams()
  const dispatch = useDispatch();
  const [bI_ObjectiveActivitiesId, setBI_ObjectiveActivitiesId] =
    useState(null);
  const [PopupComponentViewStatus, setPopupComponentViewStatus] =
    useState(false);
  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      deleteOpjectiveActitvie: state.ObjectivesActivities.deleteObjectivesActivities,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });


  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  //to show popup by popup props on add or edit
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => { },
    componentBody: <ObjectivesActivitiesAddEdit />,
    maxWidth: "500px",
    maxHeight: "800px",
    title: "انشطة الأهداف",
  };
  const RequestAccessor = [
    {
      KeyName: "objectiveName",
      ShowStatus: true,
      NmaeColumn: "الهدف",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      
    },
    {
      KeyName: "activity",
      ShowStatus: true,
      NmaeColumn: "النشاط",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
   
    {
      KeyName: "schumannsContribution",
      ShowStatus: true,
      NmaeColumn: "مساهمة شومان",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,

      

    }
  ];
  const OtherMainBtns = [

    {
      Click: async (e) => {
        setBI_ObjectiveActivitiesId(e.target.value);
        closePopupEditComponent();
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "تعديل",
      ShowStatus: !shouldDisableFields,
    },
    {
      Click: async (e) => {

        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then((res) => {
          //to delete row by id after confirmed
          if (res.isConfirmed == true) {
            dispatch(
              DeleteObjectivesActivities({
                bI_ObjectiveActivitiesId: e.target.value,
              })
            );
          }
         
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف ",
      ShowStatus: !shouldDisableFields,
    },
    {
      Click: async (e) => {

        setBI_ObjectiveActivitiesId(e.target.value);
        closePopupViewComponent();
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: shouldDisableFields,
    },
  ];
  const RequestsColumns = [];
  const closePopupViewComponent = () => {
    if (PopupComponentViewStatus) {
      setPopupComponentViewStatus(false);
    } else {
      setPopupComponentViewStatus(true);
    }
  };

  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };
//refresh table on any action
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [state.deleteOpjectiveActitvie])
//to render html after get data
  return (state.ApplicationInformation && state.ActiveRound )||decryptToken(AppGuid.AppGuid)? (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"bI_ObjectiveActivitiesId"}
        valueButtonAction={"bI_ObjectiveActivitiesId"}
        URL={`api/ObjectivesActivities/GetObjectivesActivitiesListByAppGuid`}
        UrlBody={{
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          ) || decryptToken(AppGuid.AppGuid),
          objectivesId: 0
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"أنشطة الهدف"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      // popUpBody2={[<ShowApplication addFun={true} />]}
      // popUpId2={"ShowApplicationpopUp"}
      // popUpBody2={[
      //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
      // ]}
      // handleCloseModal={handleCloseModal}
      // showModal={showPopUp}
      />
      <PopupAHSF
        title={"انشطة الاهداف"}
        componentBody={
          <ObjectivesActivitiesAddEdit
            ViewData={true}
            disabledData={true}
            Action={"view"}
            bI_ObjectiveActivitiesId={bI_ObjectiveActivitiesId}
          />
        }
        maxWidth="500px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentViewStatus}
        isPopupOpenFunction={closePopupViewComponent}
      />

      <PopupAHSF
        title={"انشطة الاهداف"}
        componentBody={
          <ObjectivesActivitiesAddEdit
            ViewData={true}
            disabledData={false}
            Action={"edit"}
            bI_ObjectiveActivitiesId={bI_ObjectiveActivitiesId}
          />
        }
        maxWidth="500px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />
    </>
  ) : (
    ""
  );
};

export default ObjectivesActivities;
